var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { format, isAfter, isBefore, isEqual, isValid, parseISO, } from 'date-fns';
export var DEFAULT_WEEK_DAYS = {
    enUS: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ],
    ptBR: [
        'Domingo',
        'Segunda-Feira',
        'Terça-Feira',
        'Quarta-Feira',
        'Quinta-Feira',
        'Sexta-Feira',
        'Sábado',
    ],
};
export function formatDateRange(date) {
    return parseISO(format(date, 'yyyy-MM-dd'));
}
export var findSelectedDate = function (date, array) {
    var index = array.findIndex(function (i) { return isEqual(i, formatDateRange(date)); });
    return !!(index >= 0);
};
export var selectDateRange = function (date, array, hasEndDate) {
    if (hasEndDate === void 0) { hasEndDate = false; }
    var tmpRange = __spreadArray([], array, true);
    var formattedDate = formatDateRange(date);
    var index = tmpRange.findIndex(function (i) { return isEqual(i, formattedDate); });
    if (index >= 0) {
        tmpRange.splice(index, 1);
    }
    else if (tmpRange.length === 1 && !hasEndDate) {
        tmpRange[0] = date;
    }
    else if (tmpRange.length < 2) {
        tmpRange.push(formattedDate);
    }
    if (tmpRange.length === 2) {
        tmpRange[1] = formattedDate;
        isAfter(tmpRange[0], tmpRange[1]) && tmpRange.reverse();
    }
    return tmpRange;
};
export var findDatesBetweenRange = function (date, array) {
    if (array.length < 2)
        return false;
    return !!(isAfter(formatDateRange(date), new Date(array[0])) &&
        isBefore(formatDateRange(date), new Date(array[1])));
};
export var transformFromStringToDateMask = function (value) {
    var sliced = value.replace(/\D/g, '').slice(0, 8);
    if (sliced.length >= 5) {
        return "".concat(sliced.slice(0, 2), "/").concat(sliced.slice(2, 4), "/").concat(sliced.slice(4));
    }
    if (sliced.length >= 3) {
        return "".concat(sliced.slice(0, 2), "/").concat(sliced.slice(2));
    }
    return sliced;
};
export var transformFromDateMaskToValidDate = function (value) {
    var _a = value.split('/'), d = _a[0], m = _a[1], y = _a[2];
    return formatDateRange(parseISO("".concat(y, "-").concat(m, "-").concat(d)));
};
export var validateAndReturnFormattedAndValidDate = function (value) {
    var date = new Date("".concat(value, "T00:00:00"));
    var values = {
        formatted: null,
        date: null,
        valid: false,
    };
    if (isValid(date)) {
        values.formatted = format(date, 'dd/MM/yyyy');
        values.date = date;
        values.valid = true;
    }
    return values;
};
export var getInitialValues = function (_a) {
    var initial = _a.initial, value = _a.value, defaultValue = _a.defaultValue;
    var date = new Date(initial ||
        (value === null || value === void 0 ? void 0 : value.start) ||
        (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.start) ||
        (value === null || value === void 0 ? void 0 : value.end) ||
        (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.end) ||
        new Date());
    return {
        initialMonth: (date.getMonth() || new Date().getMonth()),
        initialYear: date.getFullYear() || new Date().getFullYear(),
    };
};
